(() => {
  "use strict";

  const root = document.querySelector("[data-az-shell]");
  if (!root) return;

  const openButton = root.querySelector("[data-az-menu-open]");
  const menu = root.querySelector("[data-az-menu]");
  const closeButton = root.querySelector("[data-az-menu-close]");
  const overlay = root.querySelector("[data-az-menu-overlay]");
  const progress = root.querySelector("[data-az-shell-progress]");

  const setMenu = (open) => {
    root.classList.toggle("az-menu-is-open", open);
    document.documentElement.classList.toggle("az-menu-locked", open);
    if (openButton) openButton.setAttribute("aria-expanded", String(open));
    if (menu) menu.setAttribute("aria-hidden", String(!open));
  };

  openButton?.addEventListener("click", () => setMenu(true));
  closeButton?.addEventListener("click", () => setMenu(false));
  overlay?.addEventListener("click", () => setMenu(false));

  menu?.querySelectorAll("a").forEach((link) => {
    link.addEventListener("click", () => setMenu(false));
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") setMenu(false);
  });

  const updateProgress = () => {
    if (!progress) return;
    const max = document.documentElement.scrollHeight - window.innerHeight;
    const amount = max > 0 ? Math.min(100, Math.max(0, (window.scrollY / max) * 100)) : 0;
    progress.style.width = `${amount}%`;
  };

  updateProgress();
  window.addEventListener("scroll", updateProgress, { passive: true });
  window.addEventListener("resize", updateProgress);
})();
